var map = {
	"./all-appointments/all-appointments.module": [
		"./src/app/all-appointments/all-appointments.module.ts",
		"all-appointments-all-appointments-module"
	],
	"./calling/calling.module": [
		"./src/app/calling/calling.module.ts"
	],
	"./callingdoc/callingdoc.module": [
		"./src/app/callingdoc/callingdoc.module.ts"
	],
	"./changepassword/changepassword.module": [
		"./src/app/changepassword/changepassword.module.ts",
		"changepassword-changepassword-module"
	],
	"./chat/chat.module": [
		"./src/app/chat/chat.module.ts",
		"default~chat-chat-module~doctor-appointments-doctor-appointments-module~fill-form-fill-form-module~m~810c4946",
		"common",
		"chat-chat-module"
	],
	"./clientlist/clientlist.module": [
		"./src/app/clientlist/clientlist.module.ts",
		"clientlist-clientlist-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./diary/diary.module": [
		"./src/app/diary/diary.module.ts",
		"default~diary-diary-module~fill-form-fill-form-module~list-list-module~myaccount-myaccount-module~sc~186a7ad7",
		"common",
		"diary-diary-module"
	],
	"./doctor-appointments/doctor-appointments.module": [
		"./src/app/doctor-appointments/doctor-appointments.module.ts",
		"default~chat-chat-module~doctor-appointments-doctor-appointments-module~fill-form-fill-form-module~m~810c4946",
		"common",
		"doctor-appointments-doctor-appointments-module"
	],
	"./doctorlist/doctorlist.module": [
		"./src/app/doctorlist/doctorlist.module.ts",
		"doctorlist-doctorlist-module"
	],
	"./editaccount/editaccount.module": [
		"./src/app/editaccount/editaccount.module.ts",
		"editaccount-editaccount-module"
	],
	"./faqs/faqs.module": [
		"./src/app/faqs/faqs.module.ts",
		"faqs-faqs-module"
	],
	"./fill-form/fill-form.module": [
		"./src/app/fill-form/fill-form.module.ts",
		"default~chat-chat-module~doctor-appointments-doctor-appointments-module~fill-form-fill-form-module~m~810c4946",
		"default~diary-diary-module~fill-form-fill-form-module~list-list-module~myaccount-myaccount-module~sc~186a7ad7",
		"common",
		"fill-form-fill-form-module"
	],
	"./findhealth/findhealth.module": [
		"./src/app/findhealth/findhealth.module.ts",
		"findhealth-findhealth-module"
	],
	"./forgot/forgot.module": [
		"./src/app/forgot/forgot.module.ts",
		"forgot-forgot-module"
	],
	"./incoming-call/incoming-call.module": [
		"./src/app/incoming-call/incoming-call.module.ts",
		"incoming-call-incoming-call-module"
	],
	"./list/list.module": [
		"./src/app/list/list.module.ts",
		"default~diary-diary-module~fill-form-fill-form-module~list-list-module~myaccount-myaccount-module~sc~186a7ad7",
		"common",
		"list-list-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./make-payment/make-payment.module": [
		"./src/app/make-payment/make-payment.module.ts",
		"default~chat-chat-module~doctor-appointments-doctor-appointments-module~fill-form-fill-form-module~m~810c4946",
		"common",
		"make-payment-make-payment-module"
	],
	"./messages/messages.module": [
		"./src/app/messages/messages.module.ts",
		"default~chat-chat-module~doctor-appointments-doctor-appointments-module~fill-form-fill-form-module~m~810c4946",
		"common",
		"messages-messages-module"
	],
	"./my-appointments/my-appointments.module": [
		"./src/app/my-appointments/my-appointments.module.ts",
		"my-appointments-my-appointments-module"
	],
	"./myaccount/myaccount.module": [
		"./src/app/myaccount/myaccount.module.ts",
		"default~diary-diary-module~fill-form-fill-form-module~list-list-module~myaccount-myaccount-module~sc~186a7ad7",
		"common",
		"myaccount-myaccount-module"
	],
	"./notification/notification.module": [
		"./src/app/notification/notification.module.ts",
		"notification-notification-module"
	],
	"./officedetails/officedetails.module": [
		"./src/app/officedetails/officedetails.module.ts"
	],
	"./officelocation/officelocation.module": [
		"./src/app/officelocation/officelocation.module.ts",
		"officelocation-officelocation-module"
	],
	"./patientdashboard/patientdashboard.module": [
		"./src/app/patientdashboard/patientdashboard.module.ts",
		"patientdashboard-patientdashboard-module"
	],
	"./payment-option/payment-option.module": [
		"./src/app/payment-option/payment-option.module.ts",
		"payment-option-payment-option-module"
	],
	"./privacy-policy/privacy-policy.module": [
		"./src/app/privacy-policy/privacy-policy.module.ts",
		"privacy-policy-privacy-policy-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./rating/rating.module": [
		"./src/app/rating/rating.module.ts"
	],
	"./scheduleappointment/scheduleappointment.module": [
		"./src/app/scheduleappointment/scheduleappointment.module.ts",
		"default~chat-chat-module~doctor-appointments-doctor-appointments-module~fill-form-fill-form-module~m~810c4946",
		"default~diary-diary-module~fill-form-fill-form-module~list-list-module~myaccount-myaccount-module~sc~186a7ad7",
		"common",
		"scheduleappointment-scheduleappointment-module"
	],
	"./signup/signup.module": [
		"./src/app/signup/signup.module.ts",
		"signup-signup-module"
	],
	"./test/test.module": [
		"./src/app/test/test.module.ts",
		"test-test-module"
	],
	"./thank-you/thank-you.module": [
		"./src/app/thank-you/thank-you.module.ts",
		"thank-you-thank-you-module"
	],
	"./videocall/videocall.module": [
		"./src/app/videocall/videocall.module.ts",
		"videocall-videocall-module"
	],
	"./videochat/videochat.module": [
		"./src/app/videochat/videochat.module.ts",
		"videochat-videochat-module"
	],
	"./view-appointment/view-appointment.module": [
		"./src/app/view-appointment/view-appointment.module.ts"
	],
	"./view-filled-form/view-filled-form.module": [
		"./src/app/view-filled-form/view-filled-form.module.ts",
		"view-filled-form-view-filled-form-module"
	],
	"./view-form/view-form.module": [
		"./src/app/view-form/view-form.module.ts",
		"view-form-view-form-module"
	],
	"./view-policy/view-policy.module": [
		"./src/app/view-policy/view-policy.module.ts"
	],
	"./view-text/view-text.module": [
		"./src/app/view-text/view-text.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;